import React, { useRef } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { uniqueId } from 'lodash';
import ITooltipWrapper from './interfaces/ITooltipWrapper';

const TooltipWrapper = ({ children, tooltip, className } : ITooltipWrapper) => {
  const { current: id } = useRef(`tooltip-wrapper-${uniqueId()}`);

  const hasTooltip = !!tooltip;

  return (
    <>
      <div id={id} className={className}>
        {children}
      </div>
      {hasTooltip && (
        <UncontrolledTooltip target={id}>
          {tooltip}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default TooltipWrapper;
